/**
 * @file: 货架拖拽落位指示箭头
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../../cubeTree/index';
import * as UIToolkit from '../../../UIToolkit/layer/index';
import CodiSystem from '../../../codiSystem/index';
import Utils from '../../../utils/util';
import ArrowBase from '../arrow/index';
import { findDirection } from '../funcs/findDirection';
import { findTargetShelf } from '../funcs/findTargetShelf';

class InsertArrow extends ArrowBase {
    constructor() {
        super();
    }

    move(params: ArrowMoveParams): void {
        this.target = null;
        this.direction = null;

        // 查询鼠标点所在货架
        let targetFreezer: CubeId|null = findTargetShelf(params.shelfsCoordinate, params.mousePoint, params.dragCubes);

        // 没有查询到货架，落位到画布
        if (!targetFreezer) {
            this.toSketchpad();
            return;
        }

        this.toShelf(targetFreezer, params.mousePoint, params.dragCubes);
    }

    private toSketchpad(): void {
        this.target = CubeTree.findSketchpad();
        this.pointTo();
    }

    private toShelf(targetFreezer: CubeId, mousePoint: MousePoint, dragCubes: CubeId[]): void {
        // 查询鼠标点所在商品、文本框、隔板
        this.target = targetFreezer;

        // 查询鼠标在右侧还是左侧
        if (this.target) {
            this.direction = findDirection(this.target, mousePoint, dragCubes);
        }

        // 显示插入箭头
        this.pointTo();
    }

    // 鼠标箭头指向渲染
    private pointTo(): void {
        if (!this.target
            || CubeTree.isSketchpad(this.target)) {
            this.destroy();
            return;
        }

        this.pointToShelf();
    }
}

export default InsertArrow;
